import { sheetSizeChoices, type SheetSizeChoice } from "../shared/sheets";

export function SheetPresetPicker({
  value,
  onChange,
  disabled = false,
}: {
  value: SheetSizeChoice;
  onChange: (value: SheetSizeChoice) => void;
  disabled?: boolean;
}) {
  return (
    <div className="sheet-preset-field">
      <span className="sheet-preset-label">Sheet size</span>
      <div className="sheet-preset-grid" role="group" aria-label="Sheet size">
        {sheetSizeChoices.map((choice) => (
          <button
            key={choice}
            type="button"
            className={`sheet-preset-option${choice === "A3" ? " sheet-preset-extra" : ""}`}
            aria-pressed={value === choice}
            disabled={disabled}
            onClick={() => onChange(choice)}
          >
            <span
              className={`sheet-preset-icon sheet-preset-${choice.replace(":", "-").toLowerCase()}`}
              aria-hidden="true"
            />
            <span>{choice}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
